import React from 'react';

import PropTypes from 'prop-types';

import { FormSection } from 'components/FormHelper/FormSection';
import { SectionSubtitle } from 'components/FormHelper/SectionSubtitle';
import { MessageFields } from 'components/MyTaskArea/TaskDetailPage/MessageFields';
import { MessageHeader } from 'components/MyTaskArea/TaskDetailPage/MessageHeader';
import { MessageSender } from 'components/MyTaskArea/taskDetailConstants';
import { MessageType } from 'components/MyTaskArea/types';
import { getFileDisplayName } from 'components/MyTaskArea/utils/mapTaskDetail';

import './HistoricalMessage.sass';

export const HistoricalMessage = ({ message: messageData, onDownloadAttachment }) => {
  const { message, sender, senderLabel, timestamp, fields, files, attachments } = messageData;
  const isInstallerMessage = sender === MessageSender.INSTALLATEUR;
  const headerLabel = senderLabel ? `${senderLabel} Nachricht` : 'Nachricht';

  return (
    <div className="historical-message">
      <MessageHeader senderLabel={headerLabel} timestamp={timestamp} />
      {message && <p className="historical-message__text">{message}</p>}
      {fields?.length > 0 && (
        <>
          <SectionSubtitle>Übermittelte Formularfelder</SectionSubtitle>
          <MessageFields fields={fields} readOnly />
        </>
      )}
      {files?.length > 0 && (
        <div className="document-list">
          {files.map((fileEntry) => {
            if (isInstallerMessage && fileEntry.file) {
              return (
                <FormSection key={fileEntry.id} subtitle={`· ${fileEntry.documentType}`}>
                  <a
                    href={fileEntry.file.downloadUrl}
                    onClick={(e) =>
                      onDownloadAttachment(e, {
                        ...fileEntry.file,
                        displayName: getFileDisplayName(fileEntry.file),
                      })
                    }
                    className="historical-message__attachment-link">
                    {getFileDisplayName(fileEntry.file)}
                  </a>
                </FormSection>
              );
            }
            return (
              <FormSection key={fileEntry.id} subtitle={`· ${fileEntry.documentType}`}>
                <div className="historical-message__file-info">
                  <span className="historical-message__file-info__text">
                    {fileEntry.file ? getFileDisplayName(fileEntry.file) : ''}
                  </span>
                </div>
              </FormSection>
            );
          })}
        </div>
      )}
      {attachments?.length > 0 && (
        <>
          <SectionSubtitle>Angehängte Dokumente</SectionSubtitle>
          <div className="document-list">
            {attachments
              .filter((a) => a.file?.filename && !a.file?.deleted && a.downloadUrl)
              .map((attachment) => (
                <a
                  key={attachment.id}
                  href={attachment.downloadUrl}
                  onClick={(e) => onDownloadAttachment(e, attachment)}
                  className="historical-message__attachment-link">
                  {attachment.displayName}
                </a>
              ))}
          </div>
        </>
      )}
    </div>
  );
};

HistoricalMessage.propTypes = {
  message: MessageType.isRequired,
  onDownloadAttachment: PropTypes.func,
};

HistoricalMessage.defaultProps = {
  onDownloadAttachment: () => {},
};
